<template>
  <div>
    <h1>Stack</h1>
    <div class="align-left">
      <p>
        Professionally, I have consistently worked with JavaScript everywhere on the stack. <strong>Node.js</strong> (<strong>Express</strong> and <strong>Loopback</strong>) on the backend with <strong>Apollo GraphQL</strong>, and <strong>Angular</strong>, <strong>Ionic</strong> and <strong>React</strong> on the front.
      </p>

      <p>
        As for databases, I have worked with <strong>PostgreSQL</strong> and <strong>mongoDB</strong>.
      </p>

      <p>
        For personal projects, I have used <strong>Django REST Framework</strong> and <strong>Vue.js</strong> for the front.
      </p>

      <p>
        I deploy projects on <strong>DigitalOcean</strong>, <strong>Heroku</strong>, and <strong>Vercel</strong>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Specifics',
  props: {}
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
